import { WalletBalanceApiModel } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.api.model";

export interface WalletBalance {
	readonly walletGuid: string;
	readonly balance: number;
	readonly operationalBalance: number;
}

export class WalletBalanceAdapter {
	public static adapt(item: WalletBalanceApiModel): WalletBalance {
		return {
			walletGuid: item.id,
			balance: Number.parseFloat(item.balance),
			operationalBalance: Number.parseFloat(item.operational_balance)
		};
	}

	public static adaptMany(items: WalletBalanceApiModel[] = []): WalletBalance[] {
		return items.map(WalletBalanceAdapter.adapt);
	}
}
